import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LanguageModule } from '../language/language.module';
import { NotificationsSidenavComponent } from './notifications-sidenav.component';



@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    HttpClientModule,
    TranslateModule,
    HttpClientModule,
    LanguageModule,
    FlexLayoutModule,
    LanguageModule,
  ],
  declarations: [
    NotificationsSidenavComponent
  ],
  exports: [NotificationsSidenavComponent],
  bootstrap: [NotificationsSidenavComponent]
})
export class NotificationsSidenavModule { }
